<template>
  <div :class="{row: this.buttonsDef.length}" v-if="render">
    <div :class="{'col-sm-8': this.buttonsDef.length}">
      <div class="form-group" :data-code="element.code">
        <label :title="tooltip(element.label)">
          {{ t(element.label) }}
          <icons-render :propIcons="element.icons"/>
        </label>
        <input
          v-if="!useMaskInput || element.readonly"
          v-model="value"
          :name="element.name"
          :type="type"
          v-bind:class="{'empty': !value}"
          :disabled="element.readonly"
          @keyup="_changeValue"
          @blur="_blur"
          @focus="_focus"
          autocomplete="new-password"
          class="form-control"
          ref="input"
        />
        <input
          v-if="useMaskInput && !element.readonly"
          :name="element.name"
          :type="type"
          v-bind:class="{'empty': !value}"
          :disabled="element.readonly"
          :data-type="element.dataType"
          @keyup="_changeValue"
          @blur="_blur"
          @focus="_focus"
          class="form-control"
          ref="input"
        />
        <div
          v-if="!element.readonly"
          @click="_clear"
          class="input-autocomplete-clear"><i class="fa fa-close"></i>
        </div>
      </div>
    </div>
    <div v-if="this.buttonsDef.length" class="col-sm-4 pl-0 form-element-button-wrapper">
      <form-action-button
        :def="def"
        :buttonsDef="buttonsDef"
        :updateDataRequest="updateDataRequest"
        :formDataChanged="formDataChanged"/>
    </div>
  </div>

</template>

<script>
import FormElementTypes         from '../../../model/FormElementTypes'
import IconsRender              from '../../templates/widgets/icons-render'
import FormElementButtonsHelper from '../../../model/helper/forms/form-element-buttons-helper'
import FormActionButton         from '../../widgets/forms/form-action-button'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'input-box',
  components: {
    FormActionButton,
    IconsRender
  },
  props:      {
    def:               {
      type:    Object,
      default: () => {
        return {}
      }
    },
    element:           {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null
        }
      }
    },
    updateDataRequest: {
      type:    Function,
      default: null
    },
    formDataChanged:   {
      type:    Function,
      default: null
    }
  },

  data () {
    return {
      value:         null,
      type:          'text',
      originalValue: null,
      jqueryElement: null,
      useMaskInput:  false,
      buttonsDef:    [],
      render:        true
    }
  },

  created () {
    this._preprocessFieldType()
  },

  mounted () {
    this.buttonsDef = FormElementButtonsHelper.getButtonsDef(this.element)

    this._initInputmask()
  },

  methods: {

    /**
     *
     * @param value
     */
    updateValue (value) {
      value = value.value

      this.value         = value
      this.originalValue = value

      if ((value === null || value === undefined) || !this.useMaskInput) {
        return
      }

      this._initInputmask()
      this.jqueryElement.val(value)
    },

    /**
     *
     * @param values
     * @param fieldName
     */
    updateHighlighters (values, fieldName) {
      this.element.icons.forEach((icon) => {
        if (icon.def.ColumnName === fieldName) {
          icon.value = JSON.parse(values.value)
        }
      })
    },

    /**
     *
     * @private
     */
    _initInputmask () {
      if (this.jqueryElement) {
        return
      }

      let digits = undefined

      if (this.element.dataType === FormElementTypes.dataType.decimal0) {
        digits = 0
      }

      if (this.element.dataType === FormElementTypes.dataType.decimal1) {
        digits = 1
      }

      if (
        this.element.dataType === FormElementTypes.dataType.decimal2
        || this.element.dataType === FormElementTypes.dataType.money
      ) {
        digits = 2
      }

      if (this.element.dataType === FormElementTypes.dataType.decimal3) {
        digits = 3
      }

      if (this.element.dataType === FormElementTypes.dataType.decimal4) {
        digits = 4
      }

      if (digits === undefined && this.element.layout !== 'Duration') {
        return
      }

      this.jqueryElement = $(this.$refs.input)

      if (this.element.layout === 'Duration') {
        this.jqueryElement.inputmask('99:99', {
          oncomplete:     () => {
            this.value = this.jqueryElement.val()
          },
          oncleared:      () => {
            this.value = this.jqueryElement.val()
          }
        })
        return
      }

      this.jqueryElement.inputmask('decimal', {
        radixPoint:     ',',
        groupSeparator: ' ',
        digits:         digits,
        digitsOptional: false,  // - nefunguje na mobilu
        autoGroup:      true,
        prefix:         '', //No Space, this will truncate the first character
        placeholder:    '',
        rightAlign:     false,
        oncomplete:     () => {
          this.value = this.jqueryElement.val()
        },
        oncleared:      () => {
          this.value = this.jqueryElement.val()
        }
      })

    },

    /**
     *
     * @private
     */
    _changeValue () {
      if (this.useMaskInput) {
        this.value = this.jqueryElement.val()
        this.value = this.value === '' ? null : this.value
      }
      this.$emit('changeValue', { element: this.element, value: this.value })
    },

    /**
     *
     * @private
     */
    _blur () {
      if (this.originalValue === this.value) {
        return
      }

      if (this.useMaskInput) {
        this.value = this.jqueryElement.val()
        this.value = this.value === '' ? null : this.value
      }

      this.$emit('blur', { element: this.element, value: this.value })
    },

    /**
     *
     * @private
     */
    _focus () {
      this._initInputmask()
    },

    focus () {
      this.$refs.input.focus()
    },

    select () {
      this.$refs.input.select()
    },

    /**
     *
     * @private
     */
    _preprocessFieldType () {
      if (!this.element.dataType || this.element.type) {
        return
      }

      switch (this.element.dataType) {
        case FormElementTypes.dataType.money:
        case FormElementTypes.dataType.decimal0:
        case FormElementTypes.dataType.decimal1:
        case FormElementTypes.dataType.decimal2:
        case FormElementTypes.dataType.decimal3:
        case FormElementTypes.dataType.decimal4:
          this.useMaskInput = true
          this.type         = 'tel'
          break
        case FormElementTypes.dataType.decimal99:
          this.useMaskInput = false
          this.type         = 'tel'
          break
        case FormElementTypes.dataType.email:
          this.type = 'email'
          break
        default:
          this.useMaskInput = false
          this.type         = 'text'
      }

      if (this.element.layout === 'Password') {
        this.type = 'password'
      }
    },

    /**
     *
     * @private
     */
    _clear () {
      if (this.useMaskInput) {
        this.jqueryElement.val('')
      }

      this.value = null

      this._changeValue()
      this._blur()

      $(this.$refs.input).focus()
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }

  }
}
</script>
